export const setEqual = <T,>(set1: Set<T>, set2: Set<T>) => {
    return set1.size === set2.size && [...set1].every((x) => set2.has(x));
}